/*
* MONCAN Theme by Agencia ATLAS
*
* Use this file to add custom Javascript to MONCAN.  Keeping your custom
* Javascript in this file will make it easier to update the theme. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  document.addEventListener('DOMContentLoaded', function() {
    try {
      var wrapper = document.querySelector('.mc-product-view__wrapper[data-gallery-extras="true"]');
      if (!wrapper) return;

      var gallery = wrapper.querySelector('.mc-product-view__media-slider');
      if (!gallery) return;

      var slides = gallery.querySelectorAll('.mc-product-view__media-slide[data-aspectratio]');
      if (slides.length === 0) return;

      var lastSlide = slides[slides.length - 1];
      var aspectRatio = parseFloat(lastSlide.dataset.aspectratio);
      var extrasWrapper = document.createElement('div');
      extrasWrapper.className = 'wrapper--full-padded mc-product-view__gallery-extras';

      function cloneSlide(slide) {
        var clone = slide.cloneNode(true);
        clone.removeAttribute('id');
        return clone;
      }

      if (aspectRatio > 1) {
        extrasWrapper.appendChild(cloneSlide(lastSlide));
        lastSlide.classList.add('media--hidden-desktop');
      } else if (slides.length > 1) {
        var secondLast = slides[slides.length - 2];
        var row = document.createElement('div');
        row.className = 'mc-product-view__gallery-extras-row';
        row.appendChild(cloneSlide(secondLast));
        row.appendChild(cloneSlide(lastSlide));
        extrasWrapper.appendChild(row);
        lastSlide.classList.add('media--hidden-desktop');
        secondLast.classList.add('media--hidden-desktop');
      }

      // Check if parentNode exists before appending
      if (wrapper.parentNode) {
        wrapper.parentNode.appendChild(extrasWrapper);
      }
    } catch (error) {
      // Silently catch errors to prevent breaking other scripts
      console.warn('Product gallery extras error:', error);
    }
  });

  // Clean decimal endings from prices (,00 and .00)
  function cleanPriceDecimals(text) {
    if (!text) return text;
    return text.replace(/([.,])00(\s*[€£$¥₹])/g, '$2');
  }

  // Observer to clean decimals when prices are updated by theme.js
  function observePriceElement(element) {
    if (!element) return;

    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'characterData' || mutation.type === 'childList') {
          var textNode = mutation.target.nodeType === Node.TEXT_NODE ? mutation.target : mutation.target.childNodes[0];
          if (textNode && textNode.nodeType === Node.TEXT_NODE) {
            var cleaned = cleanPriceDecimals(textNode.textContent);
            if (cleaned !== textNode.textContent) {
              textNode.textContent = cleaned;
            }
          }
        }
      });
    });

    observer.observe(element, {
      childList: true,
      characterData: true,
      subtree: true
    });
  }

  // Apply to all price elements
  document.addEventListener('DOMContentLoaded', function() {
    try {
      // Observe specific price elements only
      var priceSelectors = [
        '[data-product-price]',
        '[data-compare-price]',
        '[data-product-unit-price]',
        '[data-cart-total-price]'
      ];

      priceSelectors.forEach(function(selector) {
        var elements = document.querySelectorAll(selector);
        elements.forEach(function(element) {
          // Clean initial content
          if (element.textContent) {
            element.textContent = cleanPriceDecimals(element.textContent);
          }
          // Observe for changes
          observePriceElement(element);
        });
      });
    } catch (error) {
      console.warn('Price decimal cleaning error:', error);
    }
  });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
